var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-row"},[_c('div',{staticClass:"toast-wrap",class:( _obj = {}, _obj['variant-'+_vm.variant] = _vm.variant, _obj['width-'+_vm.width] = _vm.width, _obj )},[_c('div',{staticClass:"toast-inner"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }